<div class="custom-snackbar" [ngClass]="snackBarStatus">
  <span class="snackbar-icon-content">
    <span class="icon-button mb-0 snackbar" [style.width.px]="20">
      <img src="../../../../assets/icons/snackbar.svg" alt="snackbar icon" />
    </span>
    <span class="snackbar-content">
      <div class="snackbar-msg">{{ snackBarStatus.toUpperCase() }}</div>
      <div class="snackbar-desc">{{ data.message || message }}</div>
    </span>
  </span>
  <span class="snackbar-close" (click)="dismiss()">
    <mat-icon>close</mat-icon>
  </span>
</div>
